const CreditStatusEnum = Object.freeze({
    DEFAULT_VALUE: null,
    AL_CORRIENTE: '0_up_to_date',
    EN_PERIODO_GRACIA: '1_10_grace_period',
    RETRASADO_11_30: '11_30_delayed',
    RETRASADO_31_60: '31_60_delayed',
    RETRASADO_61_90: '61_90_delayed',
    VENCIDO: '91_or_more'
});
export default CreditStatusEnum;